
import {
  Vue,
  Component,
  Prop,
} from "vue-property-decorator";
@Component({
  name: "EmptyData",
  components: {
    
  }
})
export default  class EmptyData extends Vue {
  @Prop({ type: String, default: '暂无数据' }) emptyTip?: any;
}
